import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { formatDate } from '@ifca-root/react-component/src/helpers/StringNumberFunction/formatDate'
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import { useGetFaDepreciationLedgerSummaryQuery } from 'generated/graphql'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'

export const DepreciationMain = (props: any) => {
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const {
    loading: FADepreciationLedgerSummaryLoading,
    data: { lastGeneratedDepreciation } = { lastGeneratedDepreciation: [] },
  } = useGetFaDepreciationLedgerSummaryQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
      if (
        !CompanyID ||
        CompanyID === 'undefined' ||
        CompanyID === 'null' ||
        CompanyID === ''
      ) {
        setErrDialog(true)
        setErrMessage('Please select company before continue.')
        return
      }
    },
  })

  let dummyDataDepreciation = [
    {
      DepreciationID: '1',
      Name: 'Generate Depreciation',
      LastGenerated: formatDate(lastGeneratedDepreciation),
      Action: 'generate-depreciation',
      path: `/fixed-assets/${CompanyID}/depreciation/generate-depreciation`,
    },
    {
      DepreciationID: '2',
      Name: 'History',
      LastGenerated: formatDate(lastGeneratedDepreciation),
      Action: 'history',
      path: `/fixed-assets/${CompanyID}/depreciation/history`,
    },
  ]

  return (
    <>
      {FADepreciationLedgerSummaryLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Depreciation', current: true },
        ]}
      />

      <ContentWrapper float>
        <List className="core-list">
          {dummyDataDepreciation.map((el, index) => {
            return (
              <ListItem key={index} onClick={() => history.push(el?.path)}>
                <ListItemText
                  style={{
                    textAlign: 'right',
                    marginLeft: '5px',
                  }}
                  primary={<span className="xsTitle">{el?.Name}</span>}
                  secondary={
                    <>
                      <span className="desc">
                        <span className="text">{`Last Generated`}&nbsp;</span>
                        <span className="desc" style={{ fontWeight: 'bold' }}>
                          {`${el?.LastGenerated}`}&nbsp;
                        </span>
                      </span>
                    </>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="delete">
                    <KeyboardArrowRight
                      onClick={() =>
                        history.push({
                          pathname: el?.path,
                          state: el,
                        })
                      }
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            )
          })}
        </List>
      </ContentWrapper>
    </>
  )
}
